import { API_HANDLERS } from '@/api';
import { ICompaniesFilter, IGetCompaniesRequest } from '@/types';

export const getCompanies = async (params?: IGetCompaniesRequest): Promise<ICompaniesFilter[]> => {
  try {
    const { data } = await API_HANDLERS.FILTERS.GET_COMPANY(params);

    return data.companies;
  } catch (error) {
    return Promise.reject(new Error(`Get Companies Filters Error: ${error}`));
  }
};
